import { HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError } from 'rxjs';

import { ApiErrorFactory } from '../core/error/api-error.factory';
import { SnackbarService } from '../core/service/snackbar.service';

export const skipErrorInterceptor = new HttpContextToken<boolean>(() => false);
export const showError = new HttpContextToken<boolean>(() => true);

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private apiErrorFactory: ApiErrorFactory,
    private snackBar: SnackbarService,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.context.get(skipErrorInterceptor)) {
      return next.handle(request);
    }

    const shouldShowError = request.context.get(showError);

    return next.handle(request).pipe(
      catchError(async (httpError: HttpErrorResponse) => {
        // Map the httpError to an ApiError containing a readable error message.
        const apiError = await this.apiErrorFactory.create(httpError);

        if (shouldShowError) {
          this.snackBar.showError(apiError.readableMessage);
        }

        throw apiError;
      }),
    );
  }
}
